/*
 * Public API Surface of managers-agreements
 */

export * from './pages/managers-agreements.component';
export * from './lib/managers-agreements.module';
